import React from 'react';
import { Link } from 'react-router-dom';
import LegalModal from './LegalModal';

/** Static footer fallback when Builder.io content is unavailable. */
const StaticFooter: React.FC = () => {
  const [legalModal, setLegalModal] = React.useState<{
    isOpen: boolean;
    type: 'terms' | 'privacy';
  }>({
    isOpen: false,
    type: 'terms',
  });

  return (
    <footer className="bg-dark-950 py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-2 text-sm">
            <Link to="/about-us" className="text-[#0099FF] hover:text-[#0088EE] transition-colors">
              About Us
            </Link>
            <span className="text-gray-600">•</span>
            <a href="#partner" className="text-[#0099FF] hover:text-[#0088EE] transition-colors">
              Partner With Us
            </a>
            <span className="text-gray-600">•</span>
            <a
              href="#merchandise"
              className="text-[#0099FF] hover:text-[#0088EE] transition-colors"
            >
              Merchandise
            </a>
            <span className="text-gray-600">•</span>
            <Link to="/contact" className="text-[#0099FF] hover:text-[#0088EE] transition-colors">
              Contact Us
            </Link>
            <span className="text-gray-600">•</span>
            <button
              onClick={() => setLegalModal({ isOpen: true, type: 'terms' })}
              className="text-[#0099FF] hover:text-[#0088EE] transition-colors"
            >
              Terms
            </button>
            <span className="text-gray-600">•</span>
            <button
              onClick={() => setLegalModal({ isOpen: true, type: 'privacy' })}
              className="text-[#0099FF] hover:text-[#0088EE] transition-colors"
            >
              Privacy
            </button>
          </div>
        </div>

        <div className="flex justify-center items-center gap-6 mb-6">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-gray-300 transition-colors"
            aria-label="Facebook"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-gray-300 transition-colors"
            aria-label="Twitter"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
            </svg>
          </a>
        </div>

        <div className="text-center mb-4">
          <p className="text-gray-400 text-sm">© Copyright 2025 • All Rights Reserved</p>
        </div>

        <div className="text-center">
          <p className="text-gray-400 text-sm">PRAIRI and its unicorn are registered trademarks.</p>
        </div>
      </div>
      <LegalModal
        isOpen={legalModal.isOpen}
        onClose={() => setLegalModal({ ...legalModal, isOpen: false })}
        type={legalModal.type}
      />
    </footer>
  );
};

export default StaticFooter;
